export default __webpack_public_path__ + "static/media/018-tools-and-utensils-2.d08c6863.png";